import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.22668 5.1667C5.38342 4.72115 5.69279 4.34544 6.09999 4.10612C6.50719 3.86681 6.98595 3.77933 7.45147 3.85918C7.91699 3.93902 8.33923 4.18105 8.6434 4.54239C8.94758 4.90372 9.11406 5.36105 9.11335 5.83337C9.11335 7.1667 7.11335 7.83337 7.11335 7.83337M7.16669 10.5H7.1721M13.8333 7.16667C13.8333 10.8486 10.8486 13.8333 7.16667 13.8333C3.48477 13.8333 0.5 10.8486 0.5 7.16667C0.5 3.48477 3.48477 0.5 7.16667 0.5C10.8486 0.5 13.8333 3.48477 13.8333 7.16667Z",
		stroke: "#03142E",
		strokeOpacity: .6,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconBaseHelp;
